const autoCategoryUserSitePublisherDevelopment = {
  id: 6,
  count_positions: 43,
  count_day: 2,
  count_site_publisher: 4,
  positions: {
    '250': {
      '0': {
        title: 'جایگاه های مستقل',
        price: 25000,
        positions: [
          'hilite-position-2',
          'hilite-position-1',
          'hilite-position-3'
        ],
        positions_report: [
          {
            price: 10000,
            size: '180-600',
            base_price: 30000,
            count: 3,
            tag_html_id: 'hilite-position-2'
          },
          {
            price: 5000,
            size: '180-600',
            base_price: 10000,
            count: 2,
            tag_html_id: 'hilite-position-1'
          },
          {
            price: 10000,
            size: '970-90',
            base_price: 10000,
            count: 1,
            tag_html_id: 'hilite-position-3'
          }
        ]
      },
      '1': {
        title: 'صفحه اصلی',
        price: 50000,
        positions: [
          'hilite-position-27',
          'hilite-position-28',
          'hilite-position-26',
          'hilite-position-198'
        ],
        positions_report: [
          {
            price: 10000,
            size: '300-600',
            base_price: 30000,
            count: 3,
            tag_html_id: 'hilite-position-27'
          },
          {
            price: 10000,
            size: '120-600',
            base_price: 20000,
            count: 2,
            tag_html_id: 'hilite-position-28'
          },
          {
            price: 10000,
            size: '300-600',
            base_price: 20000,
            count: 2,
            tag_html_id: 'hilite-position-26'
          },
          {
            price: 20000,
            size: '180-600',
            base_price: 60000,
            count: 3,
            tag_html_id: 'hilite-position-198'
          }
        ]
      },
      '5': {
        title: 'صفحات مطالب',
        price: 25000,
        positions: [
          'hilite-position-47',
          'hilite-position-48',
          'hilite-position-46'
        ],
        positions_report: [
          {
            price: 10000,
            size: '180-600',
            base_price: 30000,
            count: 3,
            tag_html_id: 'hilite-position-47'
          },
          {
            price: 5000,
            size: '300-600',
            base_price: 10000,
            count: 2,
            tag_html_id: 'hilite-position-48'
          },
          {
            price: 10000,
            size: '970-90',
            base_price: 30000,
            count: 3,
            tag_html_id: 'hilite-position-46'
          }
        ]
      },
      url: 'https://batmatic-test.ir'
    },
    '251': {
      '0': {
        title: 'جایگاه های مستقل',
        price: 40000,
        positions: [
          'hilite-position-7',
          'hilite-position-8',
          'hilite-position-6'
        ],
        positions_report: [
          {
            price: 10000,
            size: '300-600',
            base_price: 10000,
            count: 1,
            tag_html_id: 'hilite-position-7'
          },
          {
            price: 10000,
            size: '300-600',
            base_price: 30000,
            count: 3,
            tag_html_id: 'hilite-position-8'
          },
          {
            price: 20000,
            size: '300-250',
            base_price: 40000,
            count: 2,
            tag_html_id: 'hilite-position-6'
          }
        ]
      },
      '6': {
        title: 'صفحه اصلی',
        price: 25000,
        positions: [
          'hilite-position-53',
          'hilite-position-52',
          'hilite-position-51'
        ],
        positions_report: [
          {
            price: 5000,
            size: '970-90',
            base_price: 10000,
            count: 2,
            tag_html_id: 'hilite-position-53'
          },
          {
            price: 10000,
            size: '300-600',
            base_price: 10000,
            count: 1,
            tag_html_id: 'hilite-position-52'
          },
          {
            price: 10000,
            size: '300-250',
            base_price: 10000,
            count: 1,
            tag_html_id: 'hilite-position-51'
          }
        ]
      },
      '8': {
        title: 'تماس با ما',
        price: 30000,
        positions: [
          'hilite-position-63',
          'hilite-position-62',
          'hilite-position-61'
        ],
        positions_report: [
          {
            price: 5000,
            size: '970-250',
            base_price: 10000,
            count: 2,
            tag_html_id: 'hilite-position-63'
          },
          {
            price: 15000,
            size: '970-250',
            base_price: 15000,
            count: 1,
            tag_html_id: 'hilite-position-62'
          },
          {
            price: 10000,
            size: '180-600',
            base_price: 10000,
            count: 1,
            tag_html_id: 'hilite-position-61'
          }
        ]
      },
      '10': {
        title: 'صفحات مطالب',
        price: 35000,
        positions: [
          'hilite-position-73',
          'hilite-position-72',
          'hilite-position-71'
        ],
        positions_report: [
          {
            price: 15000,
            size: '970-90',
            base_price: 15000,
            count: 1,
            tag_html_id: 'hilite-position-73'
          },
          {
            price: 10000,
            size: '120-600',
            base_price: 30000,
            count: 3,
            tag_html_id: 'hilite-position-72'
          },
          {
            price: 10000,
            size: '970-90',
            base_price: 10000,
            count: 1,
            tag_html_id: 'hilite-position-71'
          }
        ]
      },
      url: 'https://barikell-test.ir'
    },
    '253': {
      '0': {
        title: 'جایگاه های مستقل',
        price: 35000,
        positions: [
          'hilite-position-17',
          'hilite-position-16',
          'hilite-position-19',
          'hilite-position-20'
        ],
        positions_report: [
          {
            price: 5000,
            size: '720-300',
            base_price: 10000,
            count: 2,
            tag_html_id: 'hilite-position-17'
          },
          {
            price: 10000,
            size: '720-300',
            base_price: 30000,
            count: 3,
            tag_html_id: 'hilite-position-16'
          },
          {
            price: 10000,
            size: '120-600',
            base_price: 20000,
            count: 2,
            tag_html_id: 'hilite-position-19'
          },
          {
            price: 10000,
            size: '180-600',
            base_price: 10000,
            count: 1,
            tag_html_id: 'hilite-position-20'
          }
        ]
      },
      '16': {
        title: 'صفحه اصلی',
        price: 20000,
        positions: [
          'hilite-position-103',
          'hilite-position-102',
          'hilite-position-101'
        ],
        positions_report: [
          {
            price: 5000,
            size: '720-300',
            base_price: 10000,
            count: 2,
            tag_html_id: 'hilite-position-103'
          },
          {
            price: 5000,
            size: '120-600',
            base_price: 10000,
            count: 2,
            tag_html_id: 'hilite-position-102'
          },
          {
            price: 10000,
            size: '300-250',
            base_price: 10000,
            count: 1,
            tag_html_id: 'hilite-position-101'
          }
        ]
      },
      '17': {
        title: 'درباره سیتا',
        price: 15000,
        positions: [
          'hilite-position-108',
          'hilite-position-109'
        ],
        positions_report: [
          {
            price: 10000,
            size: '300-600',
            base_price: 20000,
            count: 2,
            tag_html_id: 'hilite-position-108'
          },
          {
            price: 5000,
            size: '970-90',
            base_price: 10000,
            count: 2,
            tag_html_id: 'hilite-position-109'
          }
        ]
      },
      '18': {
        title: 'ارتباط باما',
        price: 35000,
        positions: [
          'hilite-position-113',
          'hilite-position-112',
          'hilite-position-111'
        ],
        positions_report: [
          {
            price: 15000,
            size: '180-600',
            base_price: 15000,
            count: 1,
            tag_html_id: 'hilite-position-113'
          },
          {
            price: 10000,
            size: '300-250',
            base_price: 10000,
            count: 1,
            tag_html_id: 'hilite-position-112'
          },
          {
            price: 10000,
            size: '970-90',
            base_price: 30000,
            count: 3,
            tag_html_id: 'hilite-position-111'
          }
        ]
      },
      '19': {
        title: 'صفحات محصولات',
        price: 45000,
        positions: [
          'hilite-position-118',
          'hilite-position-117',
          'hilite-position-120'
        ],
        positions_report: [
          {
            price: 20000,
            size: '300-250',
            base_price: 20000,
            count: 1,
            tag_html_id: 'hilite-position-118'
          },
          {
            price: 5000,
            size: '120-600',
            base_price: 15000,
            count: 3,
            tag_html_id: 'hilite-position-117'
          },
          {
            price: 20000,
            size: '120-600',
            base_price: 20000,
            count: 1,
            tag_html_id: 'hilite-position-120'
          }
        ]
      },
      '20': {
        title: 'صفحات مطالب',
        price: 25000,
        positions: [
          'hilite-position-123',
          'hilite-position-122',
          'hilite-position-125'
        ],
        positions_report: [
          {
            price: 5000,
            size: '300-250',
            base_price: 15000,
            count: 3,
            tag_html_id: 'hilite-position-123'
          },
          {
            price: 10000,
            size: '970-90',
            base_price: 20000,
            count: 2,
            tag_html_id: 'hilite-position-122'
          },
          {
            price: 10000,
            size: '120-600',
            base_price: 20000,
            count: 2,
            tag_html_id: 'hilite-position-125'
          }
        ]
      },
      url: 'https://lola-baradaran-test.ir'
    },
    '261': {
      '26': {
        title: 'صفحه تماس با ما',
        price: 20000,
        positions: [
          'hilite-position-156'
        ],
        positions_report: [
          {
            price: 20000,
            size: '300-600',
            base_price: 60000,
            count: 3,
            tag_html_id: 'hilite-position-156'
          }
        ]
      },
      '27': {
        title: 'صفحات مطالب',
        price: 10000,
        positions: [
          'hilite-position-157'
        ],
        positions_report: [
          {
            price: 10000,
            size: '720-300',
            base_price: 10000,
            count: 1,
            tag_html_id: 'hilite-position-157'
          }
        ]
      },
      '28': {
        title: 'صفحه تست 2',
        price: 20000,
        positions: [
          'hilite-position-158'
        ],
        positions_report: [
          {
            price: 20000,
            size: '180-600',
            base_price: 60000,
            count: 3,
            tag_html_id: 'hilite-position-158'
          }
        ]
      },
      url: 'https://rubitools-test.ir'
    }
  }
};

const autoCategoryUserSitePublisherProduction = {
  id: 6,
  count_positions: 30,
  count_day: 2,
  count_site_publisher: 4,
  positions: {
    1: {
      0: {
        title: "جایگاه های مستقل",
        price: 4500,
        positions: ["hilite-position-1268"],
        positions_report: [
          {
            tag_html_id: "hilite-position-1268",
            size: "300-250",
            count: 3,
            base_price: 13500,
            price: 4500,
          },
        ],
      },
      379: {
        title: "صفحه اصلی",
        price: 14500,
        positions: [
          "hilite-position-1269",
          "hilite-position-1270",
          "hilite-position-1271",
        ],
        positions_report: [
          {
            tag_html_id: "hilite-position-1269",
            size: "970-90",
            count: 3,
            base_price: 10500,
            price: 3500,
          },
          {
            tag_html_id: "hilite-position-1270",
            size: "970-250",
            count: 3,
            base_price: 13500,
            price: 4500,
          },
          {
            tag_html_id: "hilite-position-1271",
            size: "720-300",
            count: 3,
            base_price: 19500,
            price: 6500,
          },
        ],
      },
      382: {
        title: "محصولات",
        price: 13500,
        positions: [
          "hilite-position-1272",
          "hilite-position-1278",
          "hilite-position-1279",
          "hilite-position-1280",
        ],
        positions_report: [
          {
            tag_html_id: "hilite-position-1272",
            size: "300-250",
            count: 3,
            base_price: 13500,
            price: 4500,
          },
          {
            tag_html_id: "hilite-position-1278",
            size: "300-600",
            count: 3,
            base_price: 13500,
            price: 4500,
          },
          {
            tag_html_id: "hilite-position-1279",
            size: "120-600",
            count: 3,
            base_price: 6000,
            price: 2000,
          },
          {
            tag_html_id: "hilite-position-1280",
            size: "180-600",
            count: 3,
            base_price: 7500,
            price: 2500,
          },
        ],
      },
      383: {
        title: "درباره با ما",
        price: 3500,
        positions: ["hilite-position-1273", "hilite-position-1274"],
        positions_report: [
          {
            tag_html_id: "hilite-position-1273",
            size: "970-90",
            count: 3,
            base_price: 4500,
            price: 1500,
          },
          {
            tag_html_id: "hilite-position-1274",
            size: "720-300",
            count: 3,
            base_price: 6000,
            price: 2000,
          },
        ],
      },
      384: {
        title: "تماس با ما",
        price: 3500,
        positions: ["hilite-position-1275", "hilite-position-1276"],
        positions_report: [
          {
            tag_html_id: "hilite-position-1275",
            size: "970-90",
            count: 3,
            base_price: 4500,
            price: 1500,
          },
          {
            tag_html_id: "hilite-position-1276",
            size: "970-250",
            count: 3,
            base_price: 6000,
            price: 2000,
          },
        ],
      },
      url: "https://monirlock.ir",
    },
    2: {
      701: {
        title: "صفحه اصلی",
        price: 14500,
        positions: [
          "hilite-position-2265",
          "hilite-position-2266",
          "hilite-position-2267",
        ],
        positions_report: [
          {
            tag_html_id: "hilite-position-2265",
            size: "970-90",
            count: 3,
            base_price: 10500,
            price: 3500,
          },
          {
            tag_html_id: "hilite-position-2266",
            size: "970-250",
            count: 3,
            base_price: 13500,
            price: 4500,
          },
          {
            tag_html_id: "hilite-position-2267",
            size: "970-250",
            count: 3,
            base_price: 19500,
            price: 6500,
          },
        ],
      },
      url: "https://abuslocks.ir",
    },
    3: {
      0: {
        title: "جایگاه های مستقل",
        price: 3500,
        positions: ["hilite-position-538"],
        positions_report: [
          {
            tag_html_id: "hilite-position-538",
            size: "970-90",
            count: 3,
            base_price: 10500,
            price: 3500,
          },
        ],
      },
      143: {
        title: "صفحه اصلی",
        price: 9000,
        positions: [
          "hilite-position-540",
          "hilite-position-541",
          "hilite-position-542",
        ],
        positions_report: [
          {
            tag_html_id: "hilite-position-540",
            size: "970-90",
            count: 3,
            base_price: 9000,
            price: 3000,
          },
          {
            tag_html_id: "hilite-position-541",
            size: "970-250",
            count: 3,
            base_price: 12000,
            price: 4000,
          },
          {
            tag_html_id: "hilite-position-542",
            size: "720-300",
            count: 3,
            base_price: 6000,
            price: 2000,
          },
        ],
      },
      148: {
        title: "محصولات",
        price: 13500,
        positions: [
          "hilite-position-553",
          "hilite-position-555",
          "hilite-position-559",
          "hilite-position-560",
        ],
        positions_report: [
          {
            tag_html_id: "hilite-position-553",
            size: "300-250",
            count: 2,
            base_price: 12000,
            price: 6000,
          },
          {
            tag_html_id: "hilite-position-555",
            size: "300-600",
            count: 3,
            base_price: 12000,
            price: 4000,
          },
          {
            tag_html_id: "hilite-position-559",
            size: "180-600",
            count: 3,
            base_price: 4500,
            price: 1500,
          },
          {
            tag_html_id: "hilite-position-560",
            size: "120-600",
            count: 3,
            base_price: 6000,
            price: 2000,
          },
        ],
      },
      149: {
        title: "درباره ما",
        price: 2500,
        positions: ["hilite-position-561", "hilite-position-562"],
        positions_report: [
          {
            tag_html_id: "hilite-position-561",
            size: "970-90",
            count: 3,
            base_price: 3000,
            price: 1000,
          },
          {
            tag_html_id: "hilite-position-562",
            size: "970-250",
            count: 3,
            base_price: 4500,
            price: 1500,
          },
        ],
      },
      150: {
        title: "تماس با ما",
        price: 2500,
        positions: ["hilite-position-563", "hilite-position-564"],
        positions_report: [
          {
            tag_html_id: "hilite-position-563",
            size: "970-90",
            count: 3,
            base_price: 3000,
            price: 1000,
          },
          {
            tag_html_id: "hilite-position-564",
            size: "720-300",
            count: 3,
            base_price: 4500,
            price: 1500,
          },
        ],
      },
      url: "https://aegtools.ir",
    },
    4: {
      0: {
        title: "جایگاه های مستقل",
        price: 4500,
        positions: ["hilite-position-2102"],
        positions_report: [
          {
            tag_html_id: "hilite-position-2102",
            size: "970-90",
            count: 3,
            base_price: 13500,
            price: 4500,
          },
        ],
      },
      645: {
        title: "صفحه اصلی",
        price: 10000,
        positions: ["hilite-position-2099", "hilite-position-2100"],
        positions_report: [
          {
            tag_html_id: "hilite-position-2099",
            size: "970-90",
            count: 3,
            base_price: 10500,
            price: 3500,
          },
          {
            tag_html_id: "hilite-position-2100",
            size: "970-90",
            count: 3,
            base_price: 19500,
            price: 6500,
          },
        ],
      },
      url: "https://akada-hardware.ir",
    },
  },
};

const getAutoCategoryUserSitePublisherProduction = () => {
  if (process.env.REACT_APP_STATE == "PRODUCTION") {
    return autoCategoryUserSitePublisherProduction;
  }
  return autoCategoryUserSitePublisherDevelopment;
};

export default getAutoCategoryUserSitePublisherProduction();
